iframe {
  border: none;
}

html {
  scroll-behavior: smooth !important;
}

.mainGrid {
  flex-direction: row !important;
  padding-left: 10px;
  // flex-wrap: 'no-wrap';
}

.symmetricComparison {
  margin: 7px;
  width: 185px;
  height: 34px;
  border: 1px solid #c0c0c0 !important;
  border-radius: 4px !important;
  padding: 1px !important;
}

.symmetricComparisonWindow {
  width: 185px;
  height: 24px;
}

.visualCard {
  margin: 7px;
  width: 410px;
  height: 390px;
  background-color: #fff;
  border-radius: 8px !important;
}

.trendVisual {
  width: 1100px;
  height: 300px;
  background-color: #fff;
}

.trendVisualTitle {
  width: 1100px;
}

.weeklyLabel {
  width: 1262px;
}

.paceVisualTitle {
  width: 1200px !important;
}

.paceVisual {
  margin: 7px;
  margin-top: 0px;
  padding-top: 5px;
  width: 1200px;
  height: 550px;
  background-color: #fff;
  border-radius: 0px 0px 8px 8px;
}

.paceVisualGrid {
  position: relative;
  width: 1800px;
  background-color: #fff;
  border-radius: 8px !important;
}

.workbookVisualGrid {
  position: absolute;
  width: 1300px;
  background-color: #fff;
  border-radius: 8px !important;
}

.paceWidgetGrid {
  position: absolute;
  width: 1100px;
}

.info-icon {
  font-size: 20px !important;
}

@media (min-width: 1730px) and (max-width: 1900px) {
  .paceVisualTitle {
    width: 1100px !important;
  }

  .paceVisual {
    width: 1100px;
    height: 450px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: relative;
    width: 700px;
    background-color: #fff;
    border-radius: 8px !important;
  }
}

//
@media (min-width: 1610px) and (max-width: 1729px) {
  .paceVisualTitle {
    width: 1000px !important;
  }

  .paceVisual {
    width: 1000px;
    height: 450px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }
}

@media (min-width: 1590px) and (max-width: 1609px) {
  .paceVisualTitle {
    width: 950px !important;
  }

  .paceVisual {
    width: 950px;
    height: 450px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: relative;
    width: 700px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 1200px;
  }

  .visualCard {
    width: 390px;
    height: 370px;
    background-color: #fff;
    border-radius: 8px !important;
  }
}

@media (min-width: 1490px) and (max-width: 1589px) {
  .paceVisualTitle {
    width: 850px !important;
  }

  .paceVisual {
    width: 850px;
    height: 400px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: relative;
    width: 700px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 1010px;
  }

  .visualCard {
    width: 330px;
    height: 330px;
    background-color: #fff;
    border-radius: 8px !important;
  }
}

//
@media (min-width: 1300px) and (max-width: 1489px) {
  .paceVisualTitle {
    width: 650px !important;
  }

  .paceVisual {
    width: 650px;
    height: 350px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }
}

@media (min-width: 1232px) and (max-width: 1299px) {
  .paceVisualTitle {
    width: 600px !important;
  }

  .paceVisual {
    width: 600px;
    height: 300px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: relative;
    width: 940px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 900px;
  }

  .weeklyLabel {
    width: 940px;
  }

  .visualCard {
    width: 305px;
    height: 320px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .trendVisual {
    width: 900px;
    height: 250px;
    background-color: #fff;
  }

  .trendVisualTitle {
    width: 1100px;
  }

  .innerFilter {
    width: 220px;
    margin-left: 3px !important;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }
}

@media (min-width: 1190px) and (max-width: 1231px) {
  .paceVisualTitle {
    width: 550px !important;
  }

  .paceVisual {
    width: 550px;
    height: 300px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: absolute;
    width: 872px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 900px;
  }

  .visualCard {
    width: 280px;
    height: 320px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .trendVisual {
    width: 900px;
    height: 250px;
    background-color: #fff;
  }

  .trendVisualTitle {
    width: 1100px;
  }

  .weeklyLabel {
    width: 872px;
  }

  .innerFilter {
    width: 220px;
    margin-left: 3px !important;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }
}

@media (min-width: 1100px) and (max-width: 1189px) {
  .paceVisualTitle {
    width: 500px !important;
  }

  .paceVisual {
    width: 500px;
    height: 300px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }
  .paceVisualGrid {
    position: absolute;
    width: 785px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 780px;
  }

  .visualCard {
    width: 255px;
    height: 300px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .innerFilter {
    margin-left: 0px !important;
    padding-left: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .trendVisual {
    width: 780px;
    height: 230px;
    background-color: #fff;
  }

  .trendVisualTitle {
    width: 1100px;
  }

  .weeklyLabel {
    width: 785px;
  }
}

@media (min-width: 1050px) and (max-width: 1099px) {
  .paceVisualTitle {
    width: 420px !important;
  }

  .paceVisual {
    width: 420px;
    height: 220px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .weeklyLabel {
    width: 675px;
  }

  .paceVisualGrid {
    position: absolute;
    background-color: #fff;
    border-radius: 8px !important;
    width: 675px;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 650px;
  }

  .visualCard {
    width: 220px;
    height: 250px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .innerFilter {
    width: 200px;
    margin-left: 2px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    padding-top: 0px !important;
    padding-bottom: 5px !important;
  }

  .trendVisual {
    width: 650px;
    height: 190px;
    background-color: #fff;
  }

  .trendVisualTitle {
    width: 1100px;
  }
}

@media (min-width: 960px) and (max-width: 1049px) {
  .paceVisualTitle {
    width: 400px !important;
  }

  .trendVisual {
    width: 550px !important;
    height: 130px;
    background-color: #fff;
  }

  .trendVisualTitle {
    width: 1100px;
  }

  .weeklyLabel {
    width: 600px;
  }

  .paceVisual {
    width: 400px;
    height: 220px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  .paceVisualGrid {
    position: absolute;
    width: 600px;
    background-color: #fff;
    border-radius: 8px !important;
  }

  .paceWidgetGrid {
    position: absolute;
    width: 420px;
  }
}

@media (min-width: 940px) and (max-width: 959px) {
  .paceVisualTitle {
    width: 600px !important;
  }
  .paceVisual {
    width: 600px;
    height: 200px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }
}

@media (min-width: 0px) and (max-width: 939px) {
  .mainGrid {
    flex-direction: column !important;
  }
  .paceVisualTitle {
    width: 700px !important;
  }
  .paceVisual {
    width: 700px;
    height: 200px;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }
}

.loader {
  opacity: 0.3;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  opacity: 1;
}

.tabularVisual {
  margin: 7px;
  padding-top: 40px;
  width: 1262px;
  height: 700px;
  background-color: #fff;
  border-radius: 8px;
}

@media (min-width: 1492px) and (max-width: 1564px) {
  .tabularVisual {
    width: 1200px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 1300px) and (max-width: 1491px) {
  .tabularVisual {
    width: 1022px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 1232px) and (max-width: 1299px) {
  .tabularVisual {
    width: 940px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 1170px) and (max-width: 1231px) {
  .tabularVisual {
    width: 872px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 1100px) and (max-width: 1169px) {
  .tabularVisual {
    width: 785px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 1000px) and (max-width: 1099px) {
  .tabularVisual {
    width: 675px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 950px) and (max-width: 999px) {
  .tabularVisual {
    width: 675px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 751px) and (max-width: 949px) {
  .tabularVisual {
    width: 600px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}

@media (min-width: 0px) and (max-width: 750px) {
  .tabularVisual {
    width: 600px;
    height: 550px;
    background-color: #fff;
    border-radius: 8px;
  }
}
